import { Box, Typography } from '@mui/material';

import { Card, Section, StatusChip } from './Card';
import { PUSH_PULL_LABELS, UPPER_LOWER_LABELS } from './constants';
import { formatNumber, isNum } from './format';

const tone = (status) =>
  status === 'balanced' ? 'good' : status === 'insufficient' ? 'neutral' : 'caution';

const StatCard = ({ title, value, children }) => (
  <Card component="li" sx={{ listStyle: 'none' }}>
    <Typography variant="h3" sx={{ fontSize: 16, fontWeight: 700 }}>
      {title}
    </Typography>
    <Typography sx={{ fontSize: 28, fontWeight: 800, mt: 1 }}>{value}</Typography>
    <Box sx={{ mt: 1, fontSize: 14 }}>{children}</Box>
  </Card>
);

const Balance = ({ balance }) => {
  const pp = balance?.pushPull;
  const ul = balance?.upperLower;
  const score = balance?.score;
  return (
    <Section title="Balance" id="perf-balance">
      <Box
        component="ul"
        sx={{
          p: 0,
          m: 0,
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: '1fr', tl: 'repeat(3, 1fr)' },
        }}
      >
        <StatCard
          title="Push vs pull"
          value={isNum(pp?.ratio) ? `${formatNumber(pp.ratio, 2)} : 1` : 'Building'}
        >
          <StatusChip
            label={PUSH_PULL_LABELS[pp?.status] || PUSH_PULL_LABELS.insufficient}
            tone={tone(pp?.status)}
          />
          {isNum(pp?.pushSets) && (
            <Typography sx={{ mt: 1, fontSize: 13, opacity: 0.8 }}>
              {formatNumber(pp.pushSets)} push sets, {formatNumber(pp.pullSets)} pull sets
            </Typography>
          )}
        </StatCard>
        <StatCard
          title="Upper vs lower"
          value={isNum(ul?.ratio) ? `${formatNumber(ul.ratio, 2)} : 1` : 'Building'}
        >
          <StatusChip
            label={UPPER_LOWER_LABELS[ul?.status] || UPPER_LOWER_LABELS.insufficient}
            tone={tone(ul?.status)}
          />
          {isNum(ul?.upperSets) && (
            <Typography sx={{ mt: 1, fontSize: 13, opacity: 0.8 }}>
              {formatNumber(ul.upperSets)} upper sets, {formatNumber(ul.lowerSets)} lower sets
            </Typography>
          )}
        </StatCard>
        <StatCard
          title="Balance score"
          value={isNum(score) ? `${Math.round(score)} / 100` : 'Building'}
        >
          <Typography sx={{ fontSize: 13, opacity: 0.8 }}>
            {isNum(score)
              ? 'How evenly your training covers the body.'
              : 'We need a little more history to score this.'}
          </Typography>
        </StatCard>
      </Box>
    </Section>
  );
};

export default Balance;
